import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9100Model } from './kymw9100.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, SelectionMode, CellType } from '@grapecity/wijmo.grid';
import { KYMW9101Component } from '../kymw9101/kymw9101.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW9101OutputModel } from '../kymw9101/vo/kymw9101-output.model';
import { KYMW9101InputModel } from '../kymw9101/vo/kymw9101-input.model';
import { GetLogDataService } from './api-services/get-log-data.service';
import { OutputLogFileService } from './api-services/output-log-file.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from './../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';

/**
 * ログ検索画面を管理するクラス
 *
 * @export KYMW9100Component
 * @class KYMW9100Component
 */
@Component({
  selector: 'app-kymw9100',
  templateUrl: 'kymw9100.component.html',
  styleUrls: ['kymw9100.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9100Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw9100Model: KYMW9100Model = new KYMW9100Model();

  // ソートを行ったカラム名（項目）とソート種類（昇順、降順）をViewHelperに保持しておく。
  // (※「前へ」「次へ」検索時も利用する）
  public sortTarget: string = <string>'';
  public sortOrder: string = <string>'';
  public currentPageNo: number = <number>1;

  /**
   * DataGridの列名とテーブル物理名を紐付ける連想配列Object
   */
  private tableName: Object;

  @ViewChild('dg_logList', { static: true }) dg_logList: FlexGrid;
  @ViewChild('btn_prev', { static: true }) btn_prev: ElementRef;
  @ViewChild('btn_next', { static: true }) btn_next: ElementRef;
  @ViewChild('btn_printOut', { static: true }) btn_printOut: ElementRef;
  @ViewChild('btn_search', { static: true }) btn_search: ElementRef;

  @ViewChild('lbl_orderCode', { static: true }) lbl_orderCode: ElementRef;
  @ViewChild('lbl_nextCatalogID', { static: true }) lbl_nextCatalogID: ElementRef;
  @ViewChild('lbl_pcode', { static: true }) lbl_pcode: ElementRef;
  @ViewChild('lbl_resultIndexPos', { static: true }) lbl_resultIndexPos: ElementRef;
  @ViewChild('lbl_resultIndexFrom', { static: true }) lbl_resultIndexFrom: ElementRef;
  @ViewChild('lbl_resultIndexTo', { static: true }) lbl_resultIndexTo: ElementRef;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW9100Model;

  public kymw9101ComponentRef: ComponentRef<any> = null;
  public kymw9101Component: KYMW9101Component;

  /**
   *Creates an instance of KYMW9100Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW9100Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getLogDataService: GetLogDataService,
    private outputLogFileService: OutputLogFileService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public viewContainerRef: ViewContainerRef,
  ) {
    super(kymw00Model);

    this.tableName = new Object();
    this.tableName['PCode'] = 'PCODE';
    this.tableName['ItemCode'] = 'ITEM_CODE';
    this.tableName['CoopCode'] = 'COOP_CODE';
    this.tableName['UpdateDate'] = 'UPDATE_DATE';
    this.tableName['UserID'] = 'USER_ID';
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.kymw9100Model.kymw9100Component = this;
    this.componentName = 'KYMW9100';

    // 行ヘッダの幅を0にしてレイアウト設定
    this.dg_logList.rowHeaders.columns[0].width = 0;
    this.dg_logList.selectionMode = SelectionMode.Row;

    this.initKYMW9100();
  }

  /**
   * 初期化処理
   *
   * @memberof KYMW9100Component
   */
  public initKYMW9100(): void {
    // 受注コード、Pコード、配達企画回(翌週)、検索総件数、表示行番号(From)、表示行番号(To)を空白に表示する。
    this.kymw9100Model.orderCode = '';
    this.kymw9100Model.catalogID = '';
    this.kymw9100Model.totalNum = 0;
    this.kymw9100Model.rowCntFrom = 0;
    this.kymw9100Model.rowCntTo = 0;

    // 表示ページ番号'１'をViewHelperで保持しておく。(※１：表示ページ番号を検索条件として利用)
    this.currentPageNo = 1;

    // 「前へ」、「次へ」、「出力」ボタンを非活性化する。
    this.kymw9100Model.prevDisabled = true;
    this.kymw9100Model.nextDisabled = true;
    this.kymw9100Model.printOutDisabled = true;

    this.btn_search.nativeElement.focus();
  }

  /**
   * ログ一覧データグリッド ヘッダクリックイベント処理
   *
   * @param {MouseEvent} e
   * @param {FlexGrid} grid
   * @returns {void}
   * @memberof KYMW9100Component
   */
  public eventDgLogList_HEADERRELEASEHandler(e: MouseEvent, grid: FlexGrid): void {
    // 後続のデフォルトイベントをキャンセル
    event.preventDefault();


      // // データが0件の場合は何もしない
      // ソート可能かの判定
      if (DataGridUtil.isSortable(e, this.dg_logList)) {

      // クリックされたデータグリッドの列から、DBの物理項目を取得
      this.sortTarget = this.tableName[this.dg_logList.columns[grid.hitTest(e).col].binding];
      // 取得できなかったら何もしない
      if (!this.sortTarget) {
        return;
      }

      // データグリッドのヘッダテキストを描画し、ASCとDESCをVOに設定
      this.sortOrder = DataGridUtil.switchHeaderText(e, grid);

      // ページカウンタの初期化
      this.currentPageNo = 1;

      // サーバにデータ取得を要求(Cairngormイベント発行)
      const vo = this.kymw9100Model.getLogSearchConditionVO();
      this.getLogDataService.execute(this.kymw9100Model, vo);
    }
  }

  /**
   * 検索ボタンクリック
   *
   * @memberof KYMW9100Component
   */
  public searchBtnClicked(): void {
    // 『ログ検索条件』画面を呼び出す。
    // 保持しているログ検索条件を「ログ検索条件」画面に渡す。
    const manageTarget: KYMW9100Model = (this.kymw9100Model as KYMW9100Model) as KYMW9100Model;
    const inputVO: KYMW9101InputModel = new KYMW9101InputModel();
    if (manageTarget.coopCodeList != null) {
      inputVO.coopChibaCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_TI) !== -1 ? this.kymw00Model.COOP_CODE_TI : '';
      inputVO.coopGunmaCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_GU) !== -1 ? this.kymw00Model.COOP_CODE_GU : '';
      inputVO.coopIbarakiCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_IB) !== -1 ? this.kymw00Model.COOP_CODE_IB : '';
      inputVO.coopNaganoCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_NA) !== -1 ? this.kymw00Model.COOP_CODE_NA : '';
      inputVO.coopNiigataCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_NI) !== -1 ? this.kymw00Model.COOP_CODE_NI : '';
      inputVO.coopSaitamaCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_SA) !== -1 ? this.kymw00Model.COOP_CODE_SA : '';
      inputVO.coopTochigiCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_TO) !== -1 ? this.kymw00Model.COOP_CODE_TO : '';
      inputVO.coopTokyoCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_TK) !== -1 ? this.kymw00Model.COOP_CODE_TK : '';
      inputVO.coopKurucoCode =
        manageTarget.coopCodeList.indexOf(this.kymw00Model.COOP_CODE_KU) !== -1 ? this.kymw00Model.COOP_CODE_KU : '';
    } else {
      inputVO.coopChibaCode = 'true';
      inputVO.coopGunmaCode = 'true';
      inputVO.coopIbarakiCode = 'true';
      inputVO.coopNaganoCode = 'true';
      inputVO.coopNiigataCode = 'true';
      inputVO.coopSaitamaCode = 'true';
      inputVO.coopTochigiCode = 'true';
      inputVO.coopTokyoCode = 'true';
      inputVO.coopKurucoCode = 'true';
    }
    if (manageTarget.itemCode !== null) {
      inputVO.itemCode = manageTarget.itemCode;
    }
    if (manageTarget.orderCode !== null) {
      inputVO.orderCode = manageTarget.orderCode;
    }
    if (manageTarget.pcode !== null) {
      inputVO.pcode = manageTarget.pcode;
    }
    inputVO.searchTableCondition = manageTarget.searchTableCondition;
    inputVO.selectDuration = manageTarget.selectDuration;
    if (manageTarget.updateDateFrom !== null) {
      inputVO.updateDateFrom = manageTarget.updateDateFrom;
    }
    if (manageTarget.updateDateTo !== null) {
      inputVO.updateDateTo = manageTarget.updateDateTo;
    }
    if (manageTarget.userID !== null) {
      inputVO.userID = manageTarget.userID;
    }

    this.kymw9101ComponentRef =
      this.dialogService.openModelessSub(
        this, KYMW9101Component,
        this.viewContainerRef, this.kymw9101ComponentRef, null, 0, '', true);

    if (this.kymw9101ComponentRef != null) {
      this.kymw9101Component = this.kymw9101ComponentRef.instance as KYMW9101Component;
      this.kymw9101Component.parent = this;
      this.kymw9101Component.setInterfaceParam(inputVO);
      this.kymw9101Component.getKYMW9101Parameter = (outputVO: KYMW9101OutputModel) => this.getKYMW9101Parameter(outputVO);

      // ウィンドウが閉じられる際の処理
      this.kymw9101Component.closeFunction = () => {
        this.kymw9101ComponentRef.destroy();
      };
    }
  }

  /**
   * ログ検索条件画面戻りパラメータの設定
   *
   * @param {KYMW9101OutputModel} outputVO
   * @memberof KYMW9100Component
   */
  public getKYMW9101Parameter(outputVO: KYMW9101OutputModel): void {
    // 検索画面戻りパラメータの設定
    this.kymw9100Model.commitParams(outputVO);
    // 現在ページを１ページにする
    this.currentPageNo = 1;
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw9100Model.getLogSearchConditionVO();
    this.getLogDataService.execute(this.kymw9100Model, vo);
  }

  /**
   * 前へボタンクリック
   *
   * @param {MouseEvent} event
   * @memberof KYMW9100Component
   */
  public prevBtnClicked(event: MouseEvent): void {
    // 表示ページ番号＝表示ページ番号－1にする。
    // 表示ページ番号、ソートカラム名(項目)、ログ検索条件(※２)で検索し、「アクセスログ一覧」の表示を切り替える。
    this.currentPageNo = this.currentPageNo - 1;
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw9100Model.getLogSearchConditionVO();
    this.getLogDataService.execute(this.kymw9100Model, vo);
  }

  /**
   * 次へボタンクリック
   *
   * @param {MouseEvent} event
   * @memberof KYMW9100Component
   */
  public nextBtnClicked(event: MouseEvent): void {
    // 表示ページ番号＝表示ページ番号＋１にする。
    // 表示ページ番号、ソートカラム名、ログ検索条件(※２)で検索し、「アクセスログ一覧」の表示を切り替える。
    this.currentPageNo = this.currentPageNo + 1;
    // サーバにデータ取得を要求(Cairngormイベント発行)
    const vo = this.kymw9100Model.getLogSearchConditionVO();
    this.getLogDataService.execute(this.kymw9100Model, vo);
  }

  /**
   * 出力ボタンクリック
   *
   * @param {MouseEvent} event
   * @returns {void}
   * @memberof KYMW9100Component
   */
  public printOutBtnClicked(event: MouseEvent): void {
    // 検索総件数が500,000件を超えている場合、出力不可とする
    if (this.kymw9100Model.totalNum > 500000) {
      this.dialogService.openAlertGetMessage('E0182', ['検索総件数が500,000件']);
      return;
    }

    // ログ検索条件(※２)、ソートカラム名で検索し、
    // ログ出力ファイル(TXTファイル/Tab区切)を作成してクライアントに送信する。
    const vo = this.kymw9100Model.getLogSearchConditionVO();
    this.outputLogFileService.execute(this.kymw9100Model, vo, (data: any) => {

      // ファイル名の設定
      const fileName = 'ログ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.txt';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

}
